module.exports = __webpack_public_path__ + "img/9791187886341.317b2a02.jpg";